import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  SendAppLinkGraphql,
  WrappedResponse,
} from "@app/home/cards/download-app-card/send-app-link-graphql.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserService } from "@app/core/user.service";
import { User } from "@app/shared/user";
import { AppStoreRedirectService } from "@app/shared/app-store-redirect.service";
import { HomePageAnalyticsService } from "@app/home/home-page-analytics.service";

@Component({
  selector: "om-download-app-card",
  templateUrl: "./download-app-card.component.html",
  styleUrls: ["../default-styling.scss", "./download-app-card.component.scss"],
})
export class DownloadAppCardComponent implements OnInit {
  formGroup: FormGroup;
  formControlName: string = "phoneNumber";
  formErrorMessage: string;

  submitting: boolean;
  submitted: boolean;
  buttonText: string;

  deviceSpecificRedirectUrl: string;
  private genericRedirectUrl: string;

  private destroy$ = new Subject();

  constructor(
    private sendAppLinkGraphQL: SendAppLinkGraphql,
    private userService: UserService,
    private appStoreRedirectService: AppStoreRedirectService,
    private homePageAnalyticsService: HomePageAnalyticsService
  ) {}

  ngOnInit(): void {
    this.setInitialFormState();

    let phoneNumberControl = new FormControl({ value: undefined, disabled: false }, [
      Validators.required,
    ]);

    this.formGroup = new FormGroup({
      phoneNumber: phoneNumberControl,
    });

    const phoneControl = this.formGroup.controls[this.formControlName];

    this.userService.user$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (user: User) => {
        phoneControl.setValue(user.phoneNumber);
      },
    });
    this.userService.getUser();

    this.deviceSpecificRedirectUrl = this.appStoreRedirectService.getRedirectUrl();
    this.genericRedirectUrl = `${window.location.origin}/app-store-redirect`;
  }

  onSubmit(): void {
    let phoneNumber = `+1${this.formGroup.controls[this.formControlName].value}`;
    this.setSubmittingFormState();
    this.setErrorMessage(undefined);

    this.homePageAnalyticsService.trackDownloadAppLinkSent();

    this.sendAppLinkGraphQL
      .mutate({
        phoneNumber: phoneNumber,
        appStoreRedirectUrl: this.genericRedirectUrl,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: WrappedResponse) => {
          if (response.data.sendAppLink.success) {
            this.setSubmittedFormState();

            setTimeout(() => {
              this.setInitialFormState();
            }, 5000);
          } else {
            this.setErrorMessage(response.data.sendAppLink.errors.join(", "));
            this.setInitialFormState();
          }
        },
        error: (error: Error) => {
          this.setErrorMessage(error.message);
          this.setInitialFormState();
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setErrorMessage(errorMessage: string) {
    this.formErrorMessage = errorMessage;
  }

  private setSubmittedFormState() {
    this.submitting = false;
    this.submitted = true;
    this.buttonText = "Link Sent";
  }

  private setSubmittingFormState() {
    this.submitting = true;
    this.submitted = false;
    this.buttonText = "Sending...";
  }

  private setInitialFormState() {
    this.submitting = false;
    this.submitted = false;
    this.buttonText = "Send";
  }
}
